// extracted by mini-css-extract-plugin
export default {"root":"tweet-container_root__Mr0y3","article":"tweet-container_article__8Nvzi"};